// extracted by mini-css-extract-plugin
export default {"gradient":"Gradient_gradient__o4fKV"};